import { Avatar } from '@/lib/types/common/Avatar';
import { getAvatarById, getRandomAvatar } from '@/lib/config/avatars';

const AVATAR_STORAGE_KEY = 'selectedAvatarId';

export const getStoredAvatarId = (): string | null => {
    if (typeof window === 'undefined') return null;
    return localStorage.getItem(AVATAR_STORAGE_KEY);
};

export const setStoredAvatarId = (avatarId: string): void => {
    if (typeof window === 'undefined') return;
    localStorage.setItem(AVATAR_STORAGE_KEY, avatarId);
};

export const getPlayerAvatar = (avatarId?: string): Avatar => {
    if (avatarId) {
        const avatar = getAvatarById(avatarId);
        if (avatar) return avatar;
    }
    
    // Try to get from localStorage
    const storedAvatarId = getStoredAvatarId();
    if (storedAvatarId) {
        const avatar = getAvatarById(storedAvatarId);
        if (avatar) return avatar;
    }
    
    // Fall back to random avatar
    return getRandomAvatar();
};